function formatAriaLabel(series) {
  return `${series.title}: ${series.data.map(({
    label,
    value
  }) => `${label} ${value}`)}`;
}

export { formatAriaLabel };
